import { FC } from "react";
import { InputPriceProps } from "../../../components/form/inputNum";
import InputPrice from "../../../components/form/inputPrice";

interface TaxationFieldProps extends InputPriceProps {
  vehicleAge?: number | null;
}

const TaxationField: FC<TaxationFieldProps> = ({ vehicleAge, value, onChange, disabled, ...rest }) => {
  return (
    <>
      <InputPrice
        onChange={onChange}
        value={value || undefined}
        disabled={disabled}
        {...rest}
      />
    </>
  );
};

export default TaxationField;
